import React from 'react'

const SOCIAL_LINKS = [
    { href: 'https://x.com/Flash_Techno_Of', src: '../../assets/x.png', label: 'Flash Technologies on X' },
    { href: 'https://t.me/flashtokenenglish', src: '../../assets/telegram.png', label: 'Flash Technologies on Telegram' },
    { href: 'https://discord.gg/3peBjMuRhJ', src: '../../assets/discord.png', label: 'Flash Technologies on Discord' },
    { href: 'https://www.youtube.com/channel/UCbNApPsnWrYixnri4hwUUyA', src: '../../assets/youtube.png', label: 'Flash Technologies on YouTube' },
];

const Footer = () => {
    return (
        <div className='flex flex-col items-center gap-3 py-[70px] bg-[#1b1b1b] p-2'>
            <img src="../../assets/logo.png" alt="Flash Technologies" />
            <h5 className='text-3xl font-bold'>Flash Technologies</h5>
            <div className='bg-[#fcbf07] h-[2px] w-full max-w-[400px] opacity-60'></div>
            <p className='text-[#86888C] text-xl text-center'>Join our community for the lastest updates and exclusive offers.</p>
            <div className='flex items-center flex-wrap gap-5 my-5'>
                {SOCIAL_LINKS.map(({ href, src, label }) => (
                    <a
                        key={href}
                        href={href}
                        target='_blank'
                        rel='noopener noreferrer'
                        aria-label={label}
                    >
                        <img src={src} alt={label} />
                    </a>
                ))}
            </div>
        </div>
    );
};

export default Footer;
